export default {
  outletsForSelect: state => state.outlets.map(outlet => ({
    value: outlet.id,
    label: outlet.name,
  })),
};
